module.exports = __webpack_public_path__ + "img/链接百万自媒体力量，共创行业新生态.08f88fc0.png";